import { inject, Injectable, signal } from '@angular/core';
import { DokaModalController } from '@doka/angular-core';
import { DeleteModalComponent } from '../components/modals/delete-modal/delete-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly modalCtrl = inject(DokaModalController);

  public async openDeleteModal(text: string, title: string): Promise<boolean> {
    const modal = await this.modalCtrl.create({
      component: DeleteModalComponent,
      componentProps: {
        modalTitle: signal(title).asReadonly(),
        text: signal(text).asReadonly(),
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    return data;
  }
}
